// error code should start from 1001
module.exports = {};
